import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import {
  postUpdateApplicationTransitionRequirement,
  UpdateTransitionRequirementPayload,
} from '../../requests/postApplicationTransitionRequirement';

export const useUpdateApplicationTransitionRequirement = (
  definitionName: string,
  workflowName: string,
) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: updateTransitionRequirement, ...rest } = useMutation({
    mutationFn: ({
      uuid,
      data,
    }: {
      uuid: string;
      data: UpdateTransitionRequirementPayload;
    }) =>
      postUpdateApplicationTransitionRequirement(
        constructPost,
        uuid,
        definitionName,
        workflowName,
        data,
      ),
  });

  return { updateTransitionRequirement, ...rest };
};
